import React from 'react';
import PropTypes from 'prop-types';
import { Grid, withStyles } from '@material-ui/core';
import Styles from '../../layouts/Styles.jsx';
import NotificationChartTile from './NotificationChartTile.jsx';
import Loader from '../../components/Loaders/Loader.jsx';
import classNames from 'classnames';

const ActionitemMetrics = (props) => {
    const { classes, metricAnalysis, onChangeFilter, filters, isLoading = false, analysiscontent = [] } = props;

    return (
        <Grid container spacing={1} xs={12} justify="space-between">
            <Grid item xs={3} className={classNames(classes.cardMultiSection)} onClick={() => onChangeFilter("Client")}>
                {isLoading && <Loader />}
                <NotificationChartTile chartColor="#CBECFC" type="Client" count={metricAnalysis?.client ? metricAnalysis.client : 0} analysis={analysiscontent?.client ? analysiscontent.client : []} isHighlight={filters === "Client"} />
            </Grid>
            <Grid item xs={3} className={classNames(classes.cardMultiSection)} onClick={() => onChangeFilter("Package")}>
                {isLoading && <Loader />}
                <NotificationChartTile chartColor="#CBECFC" type="Package" count={metricAnalysis?.package ? metricAnalysis.package : 0} analysis={analysiscontent?.packages ? analysiscontent.packages : []} isHighlight={filters === "Package"} />
            </Grid>
            <Grid item xs={3} className={classNames(classes.cardMultiSection)} onClick={() => onChangeFilter("License")}>
                {isLoading && <Loader />}
                <NotificationChartTile chartColor="#CBECFC" type="License" count={metricAnalysis?.license ? metricAnalysis.license : 0} analysis={analysiscontent?.license ? analysiscontent.license : []} isHighlight={filters === "License"} />
            </Grid>
            <Grid item xs={3} className={classNames(classes.cardMultiSection)} onClick={() => onChangeFilter("All")}>
                {isLoading && <Loader />}
                <NotificationChartTile chartColor="#CBECFC" type="All" count={metricAnalysis?.all ? metricAnalysis.all : 0} analysis={analysiscontent?.all ? analysiscontent.all : []} isHighlight={filters === "All"} />
            </Grid>
        </Grid>
    );
};

ActionitemMetrics.propTypes = {
    classes: PropTypes.object,
    // analysis: PropTypes.object
    metricAnalysis: PropTypes.object,
    onChangeFilter: PropTypes.func,
    filters: PropTypes.string,
    isLoading: PropTypes.bool
};

export default withStyles((theme) => ({
    // ...ActionItemStyles(theme),
    ...Styles(theme)
}), { withTheme: true })(ActionitemMetrics);